import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store' //引入store
import VueSvgGauge from 'vue-svg-gauge'
import DatetimePicker from 'vuetify-datetime-picker'
import 'vuetify-datetime-picker/src/stylus/main.styl'
import axios from 'axios'
import VueAxios from 'vue-axios'
import excel from 'vue-excel-export'

import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  fas
} from '@fortawesome/free-solid-svg-icons'

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText
} from '@fortawesome/vue-fontawesome'
Vue.use(excel)

Vue.use(DatetimePicker)
Vue.use(VueSvgGauge)
Vue.use(VueAxios, axios)
Vue.config.devtools = true
Vue.config.productionTip = false
Vue.prototype.$axios = axios

library.add(fas)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('FontAwesomeLayers', FontAwesomeLayers)
Vue.component('FontAwesomeLayersText', FontAwesomeLayersText)

new Vue({
  vuetify,
  router,
  store,
  components: {
  
    FontAwesomeIcon
  },
  render: h => h(App)
}).$mount('#app')

